import { render, staticRenderFns } from "./paperList.vue?vue&type=template&id=f3f87eca&scoped=true&"
import script from "./paperList.vue?vue&type=script&lang=js&"
export * from "./paperList.vue?vue&type=script&lang=js&"
import style0 from "./paperList.vue?vue&type=style&index=0&id=f3f87eca&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3f87eca",
  null
  
)

export default component.exports